import makeStyles from '@material-ui/core/styles/makeStyles';
import { EContractStatus } from 'v2/interfaces/subscriptions';

export const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
    background: '#ffff',
    borderRadius: 4,
    boxShadow: '0 4px 10px 0 rgba(0,0,0,0.07)',
    width: '100%',
  },
  statusCell: {
    [`&.paid, &.negociated, &.status-${EContractStatus.EM_DIA}, &.status-${EContractStatus.FINALIZADO}`]: {
      color: '#4CAF50',
    },
    [`&.refunded, &.waiting_refund, &.status-${EContractStatus.SUSPENSO}`]: {
      color: theme.palette.error.main,
    },
    [`&.canceled, &.duplicated, &.expired, &.status-${EContractStatus.CANCELADO}`]: {
      color: '#37474F',
    },
    [`&.open, &.status-${EContractStatus.TRIAL}`]: {
      color: '#039BE5',
    },
    '&.analysing': {
      color: '#2d86ca',
    },
    [`&.recovering, &.waiting_payment, &.status-${EContractStatus.AGUARDANDO_PAGAMENTO}, &.status-${EContractStatus.ATRASADO}, &.status-${EContractStatus.INADIMPLENTE}`]:
      {
        color: '#fabb0a',
      },
    [theme.breakpoints.down('xs')]: {
      display: 'flex',
      flexDirection: 'column',
      '& p': {
        marginRight: 8,
      },
    },
  },
  status: {
    textTransform: 'uppercase',
    fontWeight: 800,
    maxWidth: 100,
  },
  gainCell: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
  },
}));
